import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Edit } from '@mui/icons-material';
import { Box, Card, CardContent, Chip, Stack, Typography } from '@mui/material';
import { useLessonsOverviewQueryApi } from 'api';
import { Button, Link, LoadingWrapper } from 'components/custom';
import NotesDialog from 'pages/lesson/Notes/NotesDialog';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import theme from 'theme';
import { getTextColor } from 'utils/color';
import { setTitle } from 'utils/head';
import { getLessonUrl } from 'utils/links';
const LessonOverview = () => {
    const { t } = useTranslation('lesson');
    const { courseId = '' } = useParams();
    const [activeLesson, setActiveLesson] = React.useState(null);
    const status = useLessonsOverviewQueryApi({ courseId });
    React.useEffect(() => {
        if (status.data) {
            setTitle(status.data.courseName);
        }
        else {
            setTitle(t('head.lessonOverviewTitle'));
        }
    }, [t, status.data]);
    return (_jsx(Stack, { height: "100%", children: _jsxs(LoadingWrapper, { status: status, children: [_jsx(Chip, { sx: {
                        '& .MuiChip-label': {
                            color: getTextColor(status.data?.courseColor),
                        },
                        backgroundColor: status.data?.courseColor,
                        width: 'fit-content',
                    }, label: status.data?.courseName }), _jsx(Stack, { gap: "1.5rem", my: "1.5rem", children: status.data?.lessons.map((lesson) => (_jsx(Card, { children: _jsxs(CardContent, { sx: {
                                '&:last-child': { padding: '1rem' },
                                display: 'grid',
                                gridTemplateColumns: 'minmax(0, 100%)',
                                padding: '1rem',
                            }, children: [_jsxs(Box, { sx: {
                                        alignItems: 'center',
                                        display: 'grid',
                                        gridTemplateColumns: 'minmax(0, 100%)',
                                        [theme.breakpoints.up('md')]: {
                                            gridTemplateColumns: 'repeat(2, minmax(0, 50%))',
                                        },
                                    }, children: [_jsx(Link, { href: getLessonUrl(lesson.id), sx: {
                                                color: 'text.secondary',
                                                fontSize: '1.2rem',
                                                textDecoration: 'none',
                                            }, children: lesson.formatedDateTimePeriod }), _jsxs(Stack, { direction: "row", alignItems: "center", justifyContent: "space-between", children: [_jsx(Typography, { sx: {
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap',
                                                    }, children: lesson.notesFirstLine }), _jsx(Button, { color: "secondary", startIcon: _jsx(Edit, {}), onClick: () => {
                                                        setActiveLesson(lesson);
                                                    } })] })] }), _jsx(Stack, { direction: "row", flexWrap: "wrap", columnGap: "0.6rem", rowGap: "0.4rem", marginTop: lesson.objects.length ? '0.5rem' : 0, children: lesson.objects.map((obj, idx) => (_jsx(Chip, { icon: _jsx(obj.Icon, {}), label: obj.name, title: obj.name, variant: "outlined", sx: {
                                            '.MuiChip-label': {
                                                fontWeight: 'normal',
                                            },
                                        } }, idx))) })] }) }, lesson.id))) }), _jsx(NotesDialog, { activeLesson: activeLesson, close: () => {
                        setActiveLesson(null);
                    } })] }) }));
};
export default LessonOverview;
